var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 10.7829C11.4813 10.7829 13.4928 8.36908 13.4928 5.39146C13.4928 2.41384 11.4813 0 8.99996 0C6.51861 0 4.50708 2.41384 4.50708 5.39146C4.50708 8.36908 6.51861 10.7829 8.99996 10.7829Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.806 15.3656C16.9973 13.7481 15.4698 12.4003 13.4929 11.5916C12.9537 11.4118 12.3247 11.4118 11.8754 11.6814C10.9769 12.2206 10.0783 12.4901 9 12.4901C7.92171 12.4901 7.02313 12.2206 6.12456 11.6814C5.67527 11.5017 5.04626 11.4118 4.50712 11.6814C2.53025 12.4901 1.00267 13.838 0.19395 15.4554C-0.435053 16.6236 0.553381 17.9715 1.90125 17.9715H16.0988C17.4466 17.9715 18.4351 16.6236 17.806 15.3656Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserS);
export default __webpack_public_path__ + "static/media/User_s.a1ce8a1a.svg";
export { ForwardRef as ReactComponent };